<div class="accordion">
  <div class="heading" fxLayout="row" fxLayoutAlign="space-between center" (click)="isExpanded = !isExpanded">
    <span>How we calculate plan price</span>
    <i class="material-icons" *ngIf="isExpanded">keyboard_arrow_up</i>
    <i class="material-icons" *ngIf="!isExpanded">keyboard_arrow_down</i>
  </div>
  <ng-content *ngIf="isExpanded"></ng-content>
</div>
